// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#error {
  text-align: center;
}

.mainDiv {
  min-height: 500px !important;
  padding: 15px 11px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/ErrorBeforeLogin/Style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":["#error {\n  text-align: center;\n}\n\n.mainDiv {\n  min-height: 500px !important;\n  padding: 15px 11px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
